import { render, staticRenderFns } from "./CMCourseBody.vue?vue&type=template&id=4de7e2f4&scoped=true&lang=pug"
import script from "./CMCourseBody.vue?vue&type=script&lang=js"
export * from "./CMCourseBody.vue?vue&type=script&lang=js"
import style0 from "./CMCourseBody.vue?vue&type=style&index=0&id=4de7e2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de7e2f4",
  null
  
)

export default component.exports